import { render } from "./InvalidInvite.vue?vue&type=template&id=b151bb90"
import script from "./InvalidInvite.vue?vue&type=script&lang=js"
export * from "./InvalidInvite.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__